import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Animal} from "src/app/infrastructure/moovement-api/models/asset";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

export interface RawAggregatedAssetState {
  id: string;
  outOfFarmSince: string | undefined;
  outOfPaddockSince: string | undefined;
  stoppedMovingSince: string | undefined;
  abnormalActivitySince: string | undefined;
  abnormalActivityStatus: Samples.AlertStatus | undefined;
  lastSeenByGatewayAt: string | undefined;
  lastSeenByBLEScannerAt: string | undefined;
  lastGPSFixAt: string | undefined;
  lastNfcGpsFixAt: string | undefined;
  position: number[] | undefined;
  lastBatteryVoltageAt: string | undefined;
  batteryVoltage: number,
  lastObservingDevice: string | undefined;
  pregnancyChance: number | undefined;
  parents: Animal[] | undefined;
  children: Animal[] | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class AggregatedAssetStateApiClient extends MoovementApiClient {



  getAggregatedAssetStates(assetIds: string[]): Observable<Array<RawAggregatedAssetState>> {
    return this.httpClient.post<Array<RawAggregatedAssetState>>(`${this.baseUrl}/api/asset/state/aggregated/list`, assetIds);
  }
}
